/* Original name trustyle.category */

/* eslint-disable react/jsx-pascal-case */

import { useState } from 'react'
import { Themed, useThemeUI } from 'theme-ui'
import { DynamicSparkIcon } from '../../elements/spark-icons/dynamic-spark-icon'

const Category = ({
  title,
  breadcrumbs: Breadcrumbs,
  hideDescriptionMobile = false,
  icon,
  iconColor = '',
}) => {
  const { theme } = useThemeUI()
  const breadcrumbsVariant = theme.elements?.category?.breadcrumbs?.variant
  const [showDescription, setShowDescription] = useState(hideDescriptionMobile)
  return (
    <>
      <If condition={Breadcrumbs || icon}>
        <div
          sx={{
            mt: ['xxs', 'sm'],
            marginBottom: 'sm',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <If condition={Breadcrumbs}>
            <Breadcrumbs.type {...Breadcrumbs.props} variant={breadcrumbsVariant} />
          </If>
          <If condition={icon && hideDescriptionMobile}>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/interactive-supports-focus */}
            <div
              role='button'
              sx={{ display: ['block', 'none'] }}
              onClick={() => setShowDescription(!showDescription)}
            >
              <DynamicSparkIcon glyph={icon} color={iconColor} size={25} />
            </div>
          </If>
        </div>
      </If>
      <Themed.h1
        sx={{
          padding: 0,
          margin: 0,
          mb: ['md', 'lg'],
          variant: 'elements.category.heading',
        }}
      >
        {title}
      </Themed.h1>
    </>
  )
}

export default Category
